import React from "react"

import { Default, Error, Success, Waiting } from "./StatusSmall.styled"
import { errorStatuses, successStatuses, waitingStatuses } from "./statusSet"

type Props = {
  status: string
}

const Status = ({ status }: Props) => {
  if (successStatuses.has(status)) return <Success>{status}</Success>
  if (waitingStatuses.has(status)) return <Waiting>{status}</Waiting>
  if (errorStatuses.has(status)) return <Error>{status}</Error>
  return <Default>{status}</Default>
}

export default Status
